var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isObjectLoading,
            expression: "isObjectLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isObjectLoading,
            expression: "!isObjectLoading",
          },
        ],
      },
      [
        _c("v-page-header", {
          attrs: { title: _vm.$t("account.profile.password.update") },
        }),
        _vm._v(" "),
        _c("v-form-message", {
          attrs: {
            id: "form-error",
            message: _vm.objectError,
            type: "error",
            isVisible: _vm.objectError !== null,
          },
        }),
        _vm._v(" "),
        _c("v-form-message", {
          attrs: {
            id: "form-success",
            message: _vm.objectSuccess,
            type: "success",
            isVisible: _vm.objectSuccess !== null,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              {
                staticClass:
                  "cell medium-9 medium-offset-1 large-11 large-offset-0",
              },
              [
                _c("v-action-buttons", {
                  attrs: {
                    items: _vm.getActionButtons,
                    isDisabled: _vm.objectFormDisabled,
                  },
                  on: { actionClicked: _vm.onClickAction },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "form-block" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "form-group--error": _vm.$v.object.password.$error,
                          "form-group--required":
                            _vm.$v.object.password.$params.required,
                        },
                      },
                      [
                        _c("label", { attrs: { for: "form-field-password" } }, [
                          _vm._v(_vm._s(_vm.$t("form.password"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.object.password.$model,
                              expression: "$v.object.password.$model",
                            },
                          ],
                          attrs: {
                            type: "password",
                            id: "form-field-password",
                            name: "password",
                          },
                          domProps: { value: _vm.$v.object.password.$model },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.object.password,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: {
                          "form-group--error":
                            _vm.$v.object.password_confirm.$error,
                          "form-group--required":
                            _vm.$v.object.password_confirm.$params.required,
                        },
                      },
                      [
                        _c(
                          "label",
                          { attrs: { for: "form-field-password-confirm" } },
                          [_vm._v(_vm._s(_vm.$t("form.password_confirm")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.$v.object.password_confirm.$model,
                              expression: "$v.object.password_confirm.$model",
                            },
                          ],
                          attrs: {
                            type: "password",
                            id: "form-field-password-confirm",
                            name: "password_confirm",
                          },
                          domProps: {
                            value: _vm.$v.object.password_confirm.$model,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.object.password_confirm,
                                "$model",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }